import showConfirm from "../libs/showConfirm";
import formActions from './common-form-actions';
import adminSubscribe from "../libs/adminSubscribeForms";
import simpleModal from "../libs/simpleModal";
import docready from "../libs/docready";

const subscriber = {};
export default subscriber;

const subscribeData = {
    cid: typeof cid !== 'undefined' ? cid : 0,
    gid: typeof gid !== 'undefined' ? gid : 0
};

subscriber.getMemberSelector = () => adminSubscribe()
    .subscribe(subscriber.getForm)
    .payment(payments.showPaymentModal)
    .cancel(subscriber.unsubscribe_event)

subscriber.getForm = function (uid = null) {
    formActions.loadForm('/site/subscriptions/get-subscribe-modal', {...subscribeData, uid: uid})
        .then(modal => {
            if (modal.length && !modal.hasClass('in')) {
                subscriber.modal = modal
                const form = modal.find('form')
                // Only show if any required fields exist
                if (form.find('.form-group').length || form.hasClass('no-autosubmit')) {
                    modal.find('.btn-continue').off('click.sendform').on('click.sendform', e => {
                        e.preventDefault();
                        subscriber.sendForm();
                    });
                    formActions.cleanForm(form);
                    modal.modal('show');
                } else {
                    // Subscribe user directly
                    subscriber.sendForm();
                }
            } else {
                console.log('some error occured - show subscribe modal');
            }
        })
        .catch(err => {
            console.log(err)
            window.openAlert(getCommonError(), 'error');
        });
}

subscriber.refreshForm = async function() {
    const form = this.modal.find('form')
    const response = await $.ajax({
        url: '/site/subscriptions/get-subscribe-form?' + $.param(subscribeData),
        type: 'POST',
        data: new FormData(form[0]),
        contentType: false,
        processData: false,
    })
    docready($(response).replaceAll(form))

}

/**
 * Send subscribe form to server
 */
subscriber.sendForm = function () {
    const modal = subscriber.modal
    let form = modal.find('form');
    formActions.cleanForm(form);
    let formData = new FormData(form[0]);
    spinner.show();

    $.ajax({
        url: '/site/groups/users-subscribe',
        data: formData,
        processData: false,
        contentType: false,
        type: 'post',
        dataType: 'json'
    }).done(function (data) {
        spinner.remove();
        if (data.success) {
            if (data.nextStep) {
                if (data.nextStep === 'payment') {
                    payments.showPaymentModal(data.id);
                    modal.modal('hide');
                }
            } else {
                modal.modal('hide');
                subscriber.registerPurchase();
                subscriber.finish(data.id, 'success');
            }

        } else {
            spinner.remove();
            formActions.applyFormErrors(form, data.errors || {}, '#{field}', '.form-group,.subscription-product-row').then(() => {
                window.openAlert(data.message || '', 'error');
                form.find('.has-error :visible:focusable:first').focus();
            });
        }
    }).fail(function () {
        spinner.remove();
        window.openAlert(window.getCommonError(), 'error');
    });
}

subscriber.log_external = async function() {
    spinner.show();
    try {
        await $.ajax({url: '/site/groups/subscribe-external', type: 'post', data: subscribeData});
    } catch (e) {
        console.log(e);
    }
    spinner.remove();
}

subscriber.unsubscribe_event = async function (id) {
    try {
        let confirmed = await showConfirm('#confirm-unsubscribe');
        if (confirmed) {
            spinner.show();
            let data = await $.ajax({
                url: '/site/groups/un-subscribe',
                type: 'POST',
                data: {
                    id: id,
                    cid: cid
                }
            })

            await openAlert(data.message || '', data.success ? 'success' : 'error');
            window.location.reload();
        }
    } catch (message) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

subscriber.registerPurchase = function () {
    // console.debug('registerPurchase')
    if (window.fbq) {
        fbq('track', 'Purchase')
    }
    if (window.gtag) {
        gtag('event', 'purchase')
    }
}

subscriber.finish = function(sid, status) {
    if (status !== 'success') {
        window.location.reload();
    }
    closeWindow().then(() => {
        const success = new simpleModal({id: 'SubscriptionResult'})
        success.$.on('click', '[data-action="close"]', () => window.location.reload())
        success.loadContent(status === 'success'
            ? {url: '/site/subscriptions/success', data: {sid}}
            : {url: '/site/subscriptions/fail'}
        )
        success.$.on('closed.cc.modal', () => {
            window.location.reload()
        })
    })
}
